import { onLoad } from '@otto-ec/global-resources/dom';

/**
 *
 *
 *
 *
 *
 */
export function afterPageLoad(callback: () => void): () => void {
    let timeout: ReturnType<typeof setTimeout> | undefined;
    const unsubscribe = onLoad.on(
        () => {
            timeout = setTimeout(callback, 0);
        },
        { once: true },
    );

    return () => {
        unsubscribe();
        clearTimeout(timeout);
    };
}
